import { render, staticRenderFns } from "./LegalDocumentFormDetailsEscalated.vue?vue&type=template&id=acc83cde&scoped=true&"
import script from "./LegalDocumentFormDetailsEscalated.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentFormDetailsEscalated.vue?vue&type=script&lang=js&"
import style0 from "./LegalDocumentFormDetailsEscalated.vue?vue&type=style&index=0&id=acc83cde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc83cde",
  null
  
)

export default component.exports